/**
 * @prettier
 */

ko.deferredComputed = function (evaluatorOrOptions, target, options) {
  options = options || {};

  if (typeof evaluatorOrOptions == "object") {
    evaluatorOrOptions.deferEvaluation = true;
  } else {
    options.deferEvaluation = true;
  }

  return ko.computed(evaluatorOrOptions, target, options);
};
